<template>
  <div class="card admin-products">
    <div class="card-body">
      <section class="container mt-3" v-if="productos.length >= 1">
        <div class="row">
          <div class="col-md-12">
            <vx-card :title="`Detalles de pedido #${id}`">

	           <vs-button
                class="py-1 px-3 d-flex align-items-center"
                color="danger"
                type="filled"
                @click="$router.push('/pedidos')"
                >
                <feather-icon
                    icon="ArrowLeftCircleIcon"
                    svgClasses="stroke-current"
                    class="mr-2"
                  />
                Regresar
                </vs-button
              >
              
	      <section class="mt-5">
                <div class="vx-row">
                  <div class="vx-col sm:w-3/4 w-full">
                    <vs-table
                      ref="table"
                      v-model="selected"
                      pagination
                      :max-items="itemsPerPage"
                      search
                      :data="productos"
                    >
                      <div
                        slot="header"
                        class="flex flex-wrap-reverse items-center flex-grow justify-between"
                      >
                        <div
                          class="flex flex-wrap-reverse items-center data-list-btn-container"
                        >
                          <!-- ACTION - DROPDOWN -->
                          <vs-dropdown
                            vs-trigger-click
                            class="dd-actions cursor-pointer mr-4 mb-4"
                            v-if="selected.length >= 1"
                          >
                            <div
                              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full"
                            >
                              <span class="mr-2">Acciones</span>
                              <feather-icon
                                icon="ChevronDownIcon"
                                svgClasses="h-4 w-4"
                              />
                            </div>

                            <vs-dropdown-menu>
                              <vs-dropdown-item>
                                <span class="flex items-center">
                                  <feather-icon
                                    icon="TrashIcon"
                                    svgClasses="h-4 w-4"
                                    class="mr-2"
                                  />
                                  <span>Eliminar</span>
                                </span>
                              </vs-dropdown-item>
                            </vs-dropdown-menu>
                          </vs-dropdown>
                        </div>
                      </div>

                      <template slot="thead">
                        <vs-th sort-key="name">Id</vs-th>
                        <vs-th sort-key="category">Nombre</vs-th>
                        <vs-th sort-key="popularity">Talla</vs-th>
                        <vs-th sort-key="order_status">Cantidad</vs-th>
                        <vs-th sort-key="order_status">Precio unidad</vs-th>
                        <!-- <vs-th>Acciones</vs-th> -->
                      </template>

                      <template slot-scope="{ data }">
                        <tbody>
                          <vs-tr
                            :data="tr"
                            :key="indextr"
                            v-for="(tr, indextr) in data"
                          >
                            <vs-td>
                              <p class="product-name font-medium truncate">
                                {{ tr.id }}
                              </p>
                            </vs-td>

                            <vs-td>
                              <p>{{ tr.nombre }}</p>
                            </vs-td>

                            <vs-td>
                              <p>{{ tr.data.ProductoTalla.Talla.nombreTalla }}</p>
                            </vs-td>

                            <vs-td>
                              <p class="product-category">
                                {{ tr.cantidad }}
                              </p>
                            </vs-td>

                            <vs-td>
                              <div>
                                  <span class="text-muted small line-through" v-if="tr.precioDescuentoPorCategoria">S/{{ formatoAPrecio(setPrecioPorProductoSinDescuento(tr)) }}</span>

                                  <span>S/ {{ formatoAPrecio(setPrecioPorProductoConDescuento(tr)) }}</span
                                >
                              </div>
                            </vs-td>

                          </vs-tr>
                        </tbody>
                      </template>
                    </vs-table>
                  </div>

                  <div class="vx-col sm:w-1/4 w-full">
                    <div class="card resumen border-0 shadow">
                      <div class="card-body pt-3">
                        <h3 class="medium-text border-bottom mt-0 mb-5 pb-2">
                          RESÚMEN DE PEDIDO
                        </h3>

                        <section>
                          <p v-if="info2.data2.Combos">
                            Los productos listados fueron comprados dentro del pack.
                            <span class="font-weight-bold">{{ info2.data2.Combos.nombre }}</span>
                          </p>

                          <div
                            class="flex justify-between border-bottom mb-3 pb-2"
                          >
                            <span>Tipo de entrega</span>

                            <p
                              class="text-danger text-right text-uppercase"
                              v-if="info2.data2"
                            >
                              {{ setTipoEnvio(info2.data2.TipoEnvio) }}
                            </p>
                          </div>

                          <div
                            class="flex justify-between border-bottom mb-3 pb-2"
                          >
                            <span>Costo de envío</span>

                            <p class="text-danger text-right">S/ {{ costo }}</p>
                          </div>

                          <div
                            class="flex justify-between border-bottom mt-3 mb-3 pb-2"
                          >
                            <span>Costo productos</span>

                            <span class="text-danger"
                              >S/ {{ setSubTotal }}</span
                            >
                          </div>

                          <div
                            class="flex justify-between border-bottom mt-3 mb-3 pb-2"
                            v-if="info2.data2.Cupones"
                          >
                            <span>Cupón desc.</span>

                            <span class="text-danger">
                              <span class="text-dark">{{ info2.data2.Cupones.codigo }}</span>
                              (-{{ info2.data2.Cupones.montoDescuento }}%)
                            </span
                            >
                          </div>

                          <div
                            class="flex justify-between border-bottom mb-3 pb-2"
                            v-if="info2.data2 && info2.data2.descuento"
                          >
                            <span>Desc. adicional</span>

                            <p class="text-danger text-right">{{ formatoAPrecio(info2.data2.descuento) }}</p>
                          </div>

                          <div
                            class="flex justify-between border-bottom mb-3 pb-2"
                          >
                            <span class="font-weight-bold">TOTAL</span>

                            <p
                              class="text-danger text-right"
                              v-if="info2.data2"
                            >
                              S/ {{ formatoAPrecio(info2.data2.precioTotal) }}
                            </p>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <!-- ticket -->
              <section v-if="info2.data2">
                <vs-button
                  color="primary"
                  :disabled="cargandoTicket"
                  type="filled"
                  @click="generarTicket()"
                  v-if="!info2.data2.ticketPdf"
                  >{{ cargandoTicket ? "Generando ticker..." : "EMITIR TICKET" }}
                </vs-button>

                <vs-button color="success" :href="info2.data2.ticketPdf" target="_blank" class="bold" v-if="info2.data2.ticketPdf">VER TICKET</vs-button>
              </section>

              <section class="mt-5" v-if="info2">
                  <h2 class="medium-text">Información adiccional:</h2>

                  <template v-if="info2.data2">
                    <div class="card border-0">
                      <div class="card-body pl-0 pt-0">
                        <div class="row border-bottom py-2">
                          <div class="col-6 col-md-2">
                            <span class="text-muted mr-2"
                              >Fecha de pedido:</span
                            >
                          </div>
                          <div class="col-6 col-md-3">
                            <span>{{
                              $dayjs(info2.data2.fechaPedido).format(
                                "DD-MM-YYYY"
                              )
                            }}</span>
                          </div>
                        </div>

                        <div class="row border-bottom py-2">
                          <div class="col-6 col-md-2">
                            <span class="text-muted mr-2">Estado:</span>
                          </div>
                          <div class="col-6 col-md-3">
                            <span>{{
                              setState(info2.data2.EstadoPedido)
                            }}</span>
                          </div>
                        </div>

                        <div class="row border-bottom py-2">
                          <div class="col-6 col-md-2">
                            <span class="text-muted mr-2"
                              >Tipo de venta:</span
                            >
                          </div>
                          <div class="col-6 col-md-3">
                            <span>{{
                              setTipoVenta(info2.data2.TipoVenta)
                            }}</span>
                          </div>
                        </div>

                        <template v-if="info2.data2.TipoVenta == 2">
                          <div class="row border-bottom py-2">
                            <div class="col-6 col-md-2">
                              <span class="text-muted mr-2"
                                >Ruc:</span
                              >
                            </div>
                            <div class="col-6 col-md-3">
                              <span>{{
                                info2.data1.ruc
                              }}</span>
                            </div>
                          </div>

                          <div class="row border-bottom py-2">
                            <div class="col-6 col-md-2">
                              <span class="text-muted mr-2"
                                >Razón social:</span
                              >
                            </div>
                            <div class="col-6 col-md-3">
                              <span>{{
                                info2.data1.razon_social
                              }}</span>
                            </div>
                          </div>
                        </template>

                        <div class="row border-bottom py-2">
                          <div class="col-6 col-md-2">
                            <span class="text-muted mr-2"
                              >Tipo de entrega:</span
                            >
                          </div>
                          <div class="col-6 col-md-3">
                            <span>{{
                              setTipoEnvio(info2.data2.TipoEnvio)
                            }}</span>
                          </div>
                        </div>

                        <div class="row border-bottom py-2">
                          <div class="col-6 col-md-2">
                            <span class="text-muted mr-2">Costo de envío:</span>
                          </div>
                          <div class="col-6 col-md-3">
                            <span
                              >S/
                              {{ formatoAPrecio(info2.data2.costoEnvio) }}</span
                            >
                          </div>
                        </div>

                        <div class="row border-bottom py-2">
                          <div class="col-6 col-md-2">
                            <span class="text-muted mr-2">Tipo de pago:</span>
                          </div>
                          <div class="col-6 col-md-3">
                            <span class="text-uppercase">{{ setTipoPago(info2.data2.TipoPago) }}</span>
                          </div>
                        </div>

                        <div
                          class="row border-bottom py-2"
                          v-if="info2.data2.banco"
                        >
                          <div class="col-6 col-md-2">
                            <span class="text-muted mr-2">Medio de pago:</span>
                          </div>
                          <div class="col-6 col-md-3">
                            <span class="text-uppercase">{{ setMedioPago(info2.data2.banco) }}</span>
                          </div>
                        </div>

                        <div class="row border-bottom py-2">
                          <div class="col-6 col-md-2">
                            <span class="text-muted mr-2"
                              >Dirección a enviar:</span
                            >
                          </div>
                          <div class="col-6 col-md-3">
                            <span>{{ info2.data2.direccionEnvio }}</span>
                          </div>
                        </div>

                        <div
                          class="row border-bottom py-2"
                          v-if="info2.data.nombreAgencia"
                        >
                          <div class="col-6 col-md-2">
                            <span class="text-muted mr-2"
                              >Nombre de agencia a enviar:</span
                            >
                          </div>
                          <div class="col-6 col-md-3">
                            <span>{{ info2.data.nombreAgencia }}</span>
                          </div>
                        </div>

                        <template v-if="info2.data3">
                          <div class="row border-bottom py-2">
                            <div class="col-6 col-md-2">
                              <span class="text-muted mr-2">Cliente:</span>
                            </div>
                            <div class="col-6 col-md-3">
                              <span>{{ cliente }}</span>
                            </div>
                          </div>

                          <div class="row border-bottom py-2" v-if="info2.data3">
                            <div class="col-6 col-md-2">
                              <span class="text-muted mr-2"
                                >Celular:</span
                              >
                            </div>

                            <div class="col-6 col-md-3">
                              <span>{{
                                info2.data.celular
                              }}</span>
                            </div>
                          </div>

                          <div class="row border-bottom py-2">
                            <div class="col-6 col-md-2">
                              <span class="text-muted mr-2"
                                >Correo electrónico:</span
                              >
                            </div>
                            <div class="col-6 col-md-3">
                              <span>{{ info2.data3.email }}</span>
                            </div>
                          </div>

                          <div
                            v-if="
                              info2.data2 &&
                              (info2.data2.TipoPago == 1 ||
                                info2.data2.TipoPago == 2)
                            "
                          >
                            <section>
                              <p
                                class="d-flex flex-column flex-md-row align-items-center border-bottom py-2"
                              >
                                <span class="text-muted mr-2">Voucher:</span>
                              </p>

                              <span v-if="!info2.data2.voucher">No se ha subido un comprobante.</span>

                              <img
                                :src="info2.data2.voucher"
                                alt=""
                                width="300px"
                                class="img-fluid"
                                v-else
                              />
                            </section>

                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
              </section>
            </vx-card>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
// Queries
import GetDetallePedido from "@/apollo/queries/pedidos/GetDetallePedido.gql";
import GetPedidoDirecciones from "@/apollo/queries/pedidos/GetPedidoDirecciones.gql";
import EmitirTicket from '@/apollo/mutations/pedidos/EmitirTicket.gql'

// Mixins
import { precio } from "@/mixins/precio";

export default {
  data() {
    return {
      id: this.$route.params.id,
      productos: [],
      info2: {},
      cargandoTicket: false,
      costo: "",
      cliente: "",
      cambiarVoucher: false,
      voucher: null,
      previewImage: "",
      loadingUpload: false,
      selected: [],
      itemsPerPage: 10,
      statusList: [
        { id: 1, label: "PEDIDO REALIZADO" },
        { id: 2, label: "PAGO APROBADO" },
        { id: 3, label: "PEDIDO ANULADO" },
        { id: 4, label: "PEDIDO EN TRANSITO" },
        { id: 5, label: "PEDIDO ENTREGADO" },
      ],
      ticket: null,
      aplicarDescuentoPorCategoria: false
    };
  },
  mounted() {
    this.init()
  },
  mixins: [precio],
  methods: {
    init() {
      this.getInfo().then(() => {
        this.getDirecciones();
      });
    },
    getInfo() {
      return new Promise((resolve) => {
        let id_pedido = this.id;

        this.$apollo
          .query({
            query: GetDetallePedido,
            fetchPolicy: "no-cache",
            variables: {
              id_pedido,
            },
          })
          .then((res) => {
            this.productos = JSON.parse(JSON.stringify(res.data.GetDetallePedidos))

            if(this.aplicarDescuentoPorCategoria) {
              this.verificarProductosMismaCategoria()
            }

            resolve();
          });
      });
    },
    verificarProductosMismaCategoria() {
      // Verificar si existen 3 productos de la misma categoría para aplicar descuento de 10%
      this.productos.forEach(producto => {
        let productosMismaCategoria = this.productos.filter(
          (item) =>
            parseInt(item.data.categoria_producto_id) === parseInt(producto.data.categoria_producto_id)
        ),
        cantidadProductosMismaCategoria = 0;

        productosMismaCategoria.forEach((p) => {
          cantidadProductosMismaCategoria += parseInt(p.cantidad);
        });

        if (cantidadProductosMismaCategoria >= 3) {
          let borradorCarrito = JSON.parse(JSON.stringify(this.productos))

          // Asignar descuento
          borradorCarrito.forEach((item) => {

            let precioAntesDeDescuento = parseFloat(item.data.ProductoTalla.precio_descuento) !== parseFloat(item.data.ProductoTalla.precio_real) ? parseFloat(item.data.ProductoTalla.precio_descuento) : parseFloat(item.data.ProductoTalla.precio_real)

            if (parseInt(item.data.categoria_producto_id) === parseInt(producto.data.categoria_producto_id)) {
              item.precioDescuentoPorCategoria = precioAntesDeDescuento - (precioAntesDeDescuento * 0.10)
            }

          });

          this.productos = borradorCarrito
        }

      })
    },
    getDirecciones() {
      let id_pedido = parseInt(this.id);

      this.$apollo
        .query({
          query: GetPedidoDirecciones,
          fetchPolicy: "no-cache",
          variables: {
            id_pedido,
          },
        })
        .then((res) => {
          this.info2 = res.data.GetPedidoDirecciones;

          this.setCosto(this.info2.data2.TipoEnvio);

          this.cliente = `${this.info2.data3.name} ${
            this.info2.data3.surnames || ""
          }`;
        });
    },
    setState(value) {
      let status = this.statusList.find(item => item.id === parseInt(value)) || null

      if(status) {
        status = status.label
      } else {
        status = 'NO ESPECIFICADO'
      }

      return status;
    },
    setTipoEnvio(value) {
      let status;

      if (value == 1) {
        status = "Envío Express";
      } else if (value == 2) {
        status = "Encomienda (Provincias)";
      } else {
        status = "Envío gratuito";
      }

      return status;
    },
    getProductsPrice() {
      // Obtiene la cantidad de productos y lo multiplica por el precio
      let total = 0,
        totalByObject = 0;

      if (this.productos) {
        this.productos.forEach((item) => {
          totalByObject = item.cantidad * parseFloat(item.precio);
          // Suma al total
          total += totalByObject;
        });
      }

      return total;
    },
    setCosto(tipoEnvio) {
      if (tipoEnvio == 1) {
        this.costo = this.formatoAPrecio(this.info2.data2.costoEnvio);
      } else if (tipoEnvio == 2) {
        this.costo = "Por confirmar";
      } else {
        this.costo = "S/ 0.00";
      }
    },
    setTipoPago(value) {
      let text = "",
        p = parseInt(value);

      if (p === 1) {
        text = "Transferencia bancaria";
      } else if (p === 2) {
        text = "Efectivo móvil";
      } else if (p === 3) {
        text = "Pago con tarjeta";
      }

      return text;
    },
    setTipoVenta(value) {
      let status;

      if (value == 1) {
        status = "Boleta";
      } else if (value == 2) {
        status = "Factura";
      } else {
        status = "Proforma";
      }

      return status;
    },
    setMedioPago(value) {
      let result = value;

      let tipoPago = parseInt(this.info2.data2.TipoPago),
        valorPagotarjeta = 3;

      if (tipoPago === valorPagotarjeta) {
        if (value === "visa") {
          result = "Visa tarjeta de crédito";
        } else if (value === "debvisa") {
          result = "Visa tarjeta de débito";
        } else if (value === "master") {
          result = "Mastercard tarjeta de crédito";
        } else if (value === "debmaster") {
          result = "Mastercard tarjeta de débito";
        } else if (value === "amex") {
          result = "American Express";
        } else if (value === "diners") {
          result = "Dinners Club";
        }
      }

      return result;
    },
    setPrecioPorProductoConDescuento(product) {
      let precioDescuento = product.data.ProductoTalla.precio_descuento,
        precioReal = product.data.ProductoTalla.precio_real

      return product.precioDescuentoPorCategoria ? product.precioDescuentoPorCategoria : precioDescuento !== precioReal ? precioDescuento : precioReal
    },
    setPrecioPorProductoSinDescuento(product) {
      let precioDescuento = product.data.ProductoTalla.precio_descuento,
        precioReal = product.data.ProductoTalla.precio_real

      return precioDescuento !== precioReal ? precioDescuento : precioReal
    },
    generarTicket() {
      this.cargandoTicket = true

      this.$apollo
        .mutate({
          mutation: EmitirTicket,
          variables: {
            pedido_id: parseInt(this.id),
          },
        })
        .then(res => {
          this.info2.data2.ticketPdf = res.data.EmitirTicket

          this.cargandoTicket = false
        })
        .catch(() => {
          this.cargandoTicket = false
        });
    }
  },
  computed: {
    setSubTotal: function() {
      let total = this.getProductsPrice()

      if(this.info2.data2.Combos) {
        total = this.info2.data2.precioCombo
      }

      return this.formatoAPrecio(total)
    },
    setPaymentShipping: function () {
      let price;

      if (this.typeShipping.id) {
        if (this.typeShipping.id == 1) {
          price = `S/ ${this.typeShipping.price}`;
        } else if (this.typeShipping.id == 3) {
          price = "GRATIS";
        }
      }

      return price;
    },
  },
};
</script>

<style lang="scss">
.admin-products {
  &__image {
    width: 50px;
    height: 50px;
  }
}

.border-bottom {
  border-bottom: 1px solid #e7e2e2;
}

.text-muted {
    color: #9c9595;
}

.bold {
  font-weight: 700;
}

.text-uppercase {
  text-transform: uppercase;
}
</style>
